module.exports = ".ui-widget-content {\n  border: none !important;\n  padding: 15px 5px 0px 5px;\n  text-align: right; }\n\n.topic-form {\n  padding-top: 30px; }\n\n.topic-form .form-field {\n    padding-bottom: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/forum/topic/topic-form/topic-form.component.scss
// module id = ./src/app/fiscalia/component/forum/topic/topic-form/topic-form.component.scss
// module chunks = main